// extracted by mini-css-extract-plugin
export default {"container":"leasing-period_container__GI8Hk"};